import http from "../http";

export const getPowerBiConfig = () => {
  return http("api/account/v2/PowerBIEmbedConfig", {
    method: "GET"
  });
};
